import * as types from './actionTypes';
import config from 'config';
import { Token } from '@kambria/kambria-contract';
import { SET_ACCOUNT_WALLET, SET_ACCOUNT_WALLET_SUCCESS } from './actionTypes';

const KAMBRIA_WALLET_ERROR = 'Kambria wallet is not registered';
const defaultState = {
  network: null,
  account: null,
  balance: null,
  kat: 0,
  kyte: 0,
  txId: null,
  visible: null,
};

/**
 * Show Kambria Wallet for users connecting to their wallets
 * @param {*} visible
 */
export const connectWallet = (visible) => {
  return (dispatch) => {
    dispatch({ type: types.CONNECT_WALLET });

    return dispatch({ type: types.CONNECT_WALLET_SUCCESS, data: { visible: visible } });
  };
};

export const setAccount = (account) => {
  return (dispatch) => {
    dispatch({ type: types.SET_ACCOUNT_WALLET });

    return dispatch({ type: types.SET_ACCOUNT_WALLET_SUCCESS, data: { account: account } });
  };
};

/**
 * Disconnect wallets
 * @param {*}
 */
export const disconnectWallet = () => {
  return (dispatch) => {
    dispatch({ type: types.DISCONNECT_WALLET_SUCCESS });

    window.kambriaWallet && window.kambriaWallet.logout();
    return dispatch({ type: types.DISCONNECT_WALLET_SUCCESS, data: { ...defaultState } });
  };
};

/**
 * Watch user info (related to blockchain) whether changed
 */
// Ethereum network
const _watchEthereumToken = (address, callback) => {
  try {
    var { web3 } = window.kambriaWallet.provider;
    if (!web3) throw new Error('Cannot find web3 instance');
  } catch (er) {
    return callback('Cannot find web3 instance', null);
  }

  const kat = new Token(config.eth.KAT.ADDRESS, web3);
  const kyte = new Token(config.eth.KYTE.ADDRESS, web3);
  kat
    .watch(address)
    .then((tokenWatcher) => {
      tokenWatcher.event.on('data', (re) => {
        return callback(null, { kat: re.BALANCE });
      });
      tokenWatcher.event.on('error', (er) => {
        return callback(er, null);
      });
    })
    .catch((er) => {
      return callback(er, null);
    });
  kyte
    .watch(address)
    .then((tokenWatcher) => {
      tokenWatcher.event.on('data', (re) => {
        return callback(null, { kyte: re.BALANCE });
      });
      tokenWatcher.event.on('error', (er) => {
        return callback(er, null);
      });
    })
    .catch((er) => {
      return callback(er, null);
    });
};
// General watch-info function
const _watchInfo = (getState, callback) => {
  try {
    var { provider } = window.kambriaWallet;
    if (!provider) throw new Error(KAMBRIA_WALLET_ERROR);
  } catch (er) {
    return callback(KAMBRIA_WALLET_ERROR, null);
  }

  return provider.watch((er, re) => {
    if (er) return callback(er, null);

    // Previous state
    const prevState = getState();
    if (prevState.account !== re.account) _watchEthereumToken(re.account, callback);
    return callback(null, re);
  });
};

export const watchInfo = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      return _watchInfo(getState, (er, re) => {
        dispatch({ type: types.WATCH_INFO });
        if (er) {
          dispatch({ type: types.WATCH_INFO_FAIL, reason: er });
          return reject(er);
        }
        dispatch({ type: types.WATCH_INFO_SUCCESS, data: re });
        return resolve(re);
      });
    });
  };
};

/**
 * Transfer KAT (Ethereum)
 */
function _transferKAT(to, amount, callback) {
  try {
    var provider = window.kambriaWallet.provider;
    console.log("provider", provider)
    var web3 = provider.web3;
  } catch (er) {
    console.log("er", er)
    return callback(KAMBRIA_WALLET_ERROR, null);
  }

  const token = new Token(config.eth.KAT.ADDRESS, web3);
  return token
    .transfer(to, amount)
    .then((txId) => {
      return callback(null, txId);
    })
    .catch((er) => {
      return callback(er, null);
    });
}

export const transferKAT = (to, amount) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      return _transferKAT(to, amount, (er, re) => {
        dispatch({ type: types.TRANSFER_KAT });
        if (er) {
          dispatch({ type: types.TRANSFER_KAT_FAIL, reason: er });
          return reject(er);
        }
        dispatch({ type: types.TRANSFER_KAT_SUCCESS, data: { txId: re } });
        return resolve(re);
      });
    });
  };
};

/**
 * Transfer KYTY (Ethereum)
 */
function _transferKYTE(to, amount, callback) {
  try {
    var provider = window.kambriaWallet.provider;
    var web3 = provider.web3;
  } catch (er) {
    return callback(KAMBRIA_WALLET_ERROR, null);
  }

  const token = new Token(config.eth.KYTE.ADDRESS, web3);
  return token
    .transfer(to, amount)
    .then((txId) => {
      return callback(null, txId);
    })
    .catch((er) => {
      return callback(er, null);
    });
}

export const transferKYTE = (to, amount) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      return _transferKYTE(to, amount, (er, re) => {
        dispatch({ type: types.TRANSFER_KYTE });
        if (er) {
          dispatch({ type: types.TRANSFER_KYTE_FAIL, reason: er });
          return reject(er);
        }
        dispatch({ type: types.TRANSFER_KYTE_SUCCESS, data: { txId: re } });
        return resolve(re);
      });
    });
  };
};
